import BidState from './BidState';

export const selectBidStatus = (store, bidId) => {
  const bid = store.bidsState.find((bid) => bid.id === bidId);
  const bidState = new BidState({...bid.state});

  return bidState;
}



// WEBPACK FOOTER //
// ./src/store/selectors/bidStatus.js